import React from 'react';

/**
 * HEADER COMPONENT - Professional dashboard header
 * Contains logo
 */
const Header = ({ 
  currentUser, 
  currentPage, 
  onLogout, 
  onNavigate, 
  showAIAssistant = true
}) => {
  
  return (
    <header className="dashboard-header">
      <div className="header-left">
        <img
          src="https://www.defindly.com/wp-content/uploads/2025/08/Logo-Defindly.png"
          alt="Defindly"
          className="logo-image"
          style={{height: '40px'}}
        />
      </div>

      <div className="header-right">
        {/* AI Assistant removed */}
      </div>
    </header>
  );
};

export default Header;